import { clsx } from 'clsx';
import { FC } from 'react';
import { Button } from 'atoms/Button';
import styles from './styles.module.css';

export const TileButton: FC<{
  text?: string;
  url?: string;
  isWide?: boolean;
}> = ({ url, isWide, text }) => {
  return !text?.length ? null : (
    <Button
      href={url}
      className={clsx(styles.button, isWide && styles.buttonWide)}
    >
      {text}
    </Button>
  );
};
